import { render } from "./OnboardingUseCaseModal.vue?vue&type=template&id=040e36f4"
import script from "./OnboardingUseCaseModal.vue?vue&type=script&lang=js"
export * from "./OnboardingUseCaseModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__